import { render, staticRenderFns } from "./listOfProducts.vue?vue&type=template&id=4f7cc114&"
import script from "./listOfProducts.vue?vue&type=script&lang=js&"
export * from "./listOfProducts.vue?vue&type=script&lang=js&"
import style0 from "./listOfProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports